<template>
  <div style="padding: 10px">
    <div class="echarts" style="width: 100%; height: 350px" >
      <v-chart :option='options'  id="geomap" :resizable="true" theme="infographic"></v-chart>
    </div>
  </div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js'
import { store } from '@/scripts/store.js'
require ('echarts/theme/infographic')

const _ = require('lodash')
const echarts = require('echarts')

export default {
  name: 'VariantCountryGeoMap',
  components: {
    'v-chart': IEcharts,
  },
  data() {
    return {
        store: store,
        options: {},
        variantFrequency: {},
    }; 
  },
  props: {
    variant: Number,
  },
  async mounted() {
    const context = this
    context.loadChart()
  },
  methods: {
    loadChart() {
      const context = this
      const series = []

      const indiaMap = store.maps.india.states
      echarts.registerMap('india', indiaMap)
      
      const data = store.datasets.importantVariants[context.variant]
      const plotData = []
      const stateCounts = {}
      const states = (_.uniq(data.state))
      data.state.forEach((o, i) => {
        if (o in stateCounts) { stateCounts[o] += data.count[i] }
        else { stateCounts[o] = data.count[i] }
      })

      let maxCount = 0
      states.forEach(o => {
        if (stateCounts[o] > maxCount) { maxCount = stateCounts[o] }
        plotData.push({name: o, value: stateCounts[o]})
      })

      context.options = {
        textStyle: { fontFamily: store.settings.theme.fontFamily },
        toolbox: {
          feature: {  
            saveAsImage: { title: 'Save as PNG', show: true, type: 'png', name: 'StateContributions_Map' },
          }
        },
        emphasis: {
          show: false,
          label: { fontWeight: 'bold' }
        },
        tooltip: {
          trigger: 'item', showDelay: 0, transitionDuration: 0.2,
          formatter: function (params) {
            const val = (isNaN(params.value)) ? 0 : params.value
            return params.name + '<br/>' + params.seriesName + ': ' + val;
          },
          textStyle: { fontWeight: 'bold' }
        }, resize: true,
        visualMap: {
          left: 10, bottom: 20, min: 1, max: maxCount, orient: 'vertical',
          itemWidth: 8, itemHeight: 50, seriesIndex: [0],
          inRange: { color: ['#ffc72e', '#b00505']},
          text: ['Max', 'Min'], calculable: true, 
          textStyle: { fontWeight: 'bold' }
        },
        geo:{
          id: 'country', show: true, map: 'india', aspectScale: 0.9, zoom: 1, roam: false, 
          itemStyle: { borderColor: '#919191', borderWidth: 1.4, borderType: 'dotted', areaColor: 'rgba(255,255,255,0.3)'},
          emphasis:{
            itemStyle: { areaColor: '#dedede', shadowOffsetX: 0, shadowOffsetY: 0, shadowBlur: 20, borderWidth: 0, shadowColor: 'rgba(0, 0, 0, 0.5)' }
          }
        },
        series: [
          { 
            type: 'map', name: '#Genomes', geoIndex: 0, data: plotData,
            label: { position: 'inside' }
          },
        ],
      }
    }
  },

    
}
</script>